import {
  Card,
  DataStatus,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {Grid, Right, Space, Text} from 'platform/foundation';

import {MercedesNaSkladeCredentials} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';

export type MercedesNaSkladeAuthenticationFormData = {
  dealerId: string;
};

export type PlatformAuthenticationFormMercedesNaSkladeProps = {
  platformCode:
    | AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE
    | AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST;
  values?: MercedesNaSkladeCredentials | null;
  isFetching?: boolean;
  isError?: boolean;
  onSubmit: FormSubmitHandler<MercedesNaSkladeAuthenticationFormData>;
};

const DEFAULT_VALUES: MercedesNaSkladeAuthenticationFormData = {
  dealerId: '',
};

export function PlatformAuthenticationFormMercedesNaSklade(
  props: PlatformAuthenticationFormMercedesNaSkladeProps
) {
  return (
    <Card title={i18n.t('general.labels.authentication')}>
      <Text size="small" color="secondary">
        {i18n.t('page.settings.labels.authenticationDescription')}
      </Text>
      <Space vertical={4} />
      <Form<MercedesNaSkladeAuthenticationFormData>
        values={props.values ?? DEFAULT_VALUES}
        onSubmit={props.onSubmit}
        shouldWatchForUnsavedChanges
      >
        {(control) => (
          <DataStatus isLoading={props.isFetching} isError={props.isError} minHeight={25}>
            <Grid columns={2}>
              <FormField
                control={control}
                name="dealerId"
                type="text"
                label={i18n.t('page.settings.labels.dealerId')}
              />
            </Grid>
            <Space vertical={4} />
            <Right>
              <FormButton control={control} type="submit" title={i18n.t('general.actions.save')} />
            </Right>
          </DataStatus>
        )}
      </Form>
    </Card>
  );
}
